import axios from 'axios';
import { getFromLocalStorage } from '../../global/helpers';

export class EditService {
  static API_SEARCH_BASE_ULR = `${process.env.REACT_APP_SEARCH_URL}/rest/default/V1/products?`;

  static API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api/v1/`;

  static role = getFromLocalStorage('role');

  static getProducts = async (searchValue: string) => {
    const response = await axios({
      method: 'get',
      url: `${EditService.API_SEARCH_BASE_ULR}searchCriteria[page_size]=50&searchCriteria[filter_groups][0][filters][0][field]=name&searchCriteria[filter_groups][0][filters][0][value]=%25${searchValue}%25&searchCriteria[filter_groups][0][filters][0][condition_type]=like`,
    });

    return response.data;
  };

  static postDataForMappings = async (
    token: string,
    sku: string,
    wareId: string,
    code: string
  ) => {
    const response = await axios({
      method: 'put',
      url: `${EditService.API_BASE_URL}mappings`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: JSON.stringify({
        sku,
        ware_id: wareId,
        mapping_code: code,
      }),
    });
    return response.data;
  };

  static deleteMappings = async (
    token: string,
    wareId: string,
    code: string
  ) => {
    const response = await axios({
      method: 'put',
      url: `${EditService.API_BASE_URL}mappings/unmap`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: JSON.stringify({
        ware_id: wareId,
        mapping_code: code,
      }),
    });
    return response.data;
  };

  static blockProductByPharmacy = async ({
    token,
    wareId,
    code,
    reason,
    sku,
    sourceCode,
  }: {
    token: string;
    wareId: string;
    code: string;
    reason: string;
    sku: string;
    sourceCode: string;
  }) => {
    const response = await axios({
      method: 'post',
      url: `${EditService.API_BASE_URL}products/block`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: JSON.stringify({
        ware_id: wareId,
        mapping_code: code,
        reason,
        sku,
        source_code: sourceCode,
        blocked: true,
      }),
    });
    return response.data;
  };

  static blockProductByNetwork = async ({
    token,
    wareId,
    code,
  }: {
    token: string;
    wareId: string;
    code: string;
  }) => {
    const response = await axios({
      method: 'put',
      url: `${EditService.API_BASE_URL}mappings/block`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: JSON.stringify({
        ware_id: wareId,
        mapping_code: code,
      }),
    });
    return response.data;
  };

  static unblockProductByNetwork = async (
    token: string,
    wareId: string,
    code: string
  ) => {
    const response = await axios({
      method: 'put',
      url: `${EditService.API_BASE_URL}mappings/unblock`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: JSON.stringify({
        ware_id: wareId,
        mapping_code: code,
      }),
    });
    return response.data;
  };

  static unblockProductByPharmacy = async ({
    token,
    wareId,
    code,
    reason,
    sku,
    sourceCode,
  }: {
    token: string;
    wareId: string;
    code: string;
    reason: string;
    sku: string;
    sourceCode: string;
  }) => {
    const response = await axios({
      method: 'post',
      url: `${EditService.API_BASE_URL}products/block`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: JSON.stringify({
        blocked: false,
        ware_id: wareId,
        mapping_code: code,
        reason,
        sku,
        source_code: sourceCode,
      }),
    });
    return response.data;
  };

  static getProductBySku = async (sku: string) => {
    const response = await axios({
      method: 'get',
      url: `${EditService.API_SEARCH_BASE_ULR}searchCriteria[filter_groups][0][filters][0][field]=sku&searchCriteria[filter_groups][0][filters][0][value]=${sku}`,
    });
    return response.data;
  };

  static postProductsInPharmacy = async (
    productName: string,
    code: string,
    // city: string,
    // search_id_pharmacies: number,
    page = 1,
    limit = 50
  ) => {
    const response = await axios({
      method: 'post',
      url: `${EditService.API_BASE_URL}search/in_pharmacy`,
      data: {
        product_name: productName, // название товара
        code, // артикул/код
        // city,                       // город
        // search_id_pharmacies,      // ID аптеки
        sorting: true,
        hide_recipe: false,
        is_beeline: false,
        page,
        limit,
      },
    });
    return response.data;
  };
}
